<template>
    <div v-if="current">
      <v-row>
        <v-col cols="12" sm="4">
          <v-alert dense text type="info">
            {{ counter }} registros encontrados
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
          <v-btn color="primary" @click="power()" block><v-icon>mdi-home-lightning-bolt</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-simple-table>
        <thead>
          <tr>
            <th>Serial</th>
            <th>OLT</th>
            <th>F/S/P</th>
            <th>ID</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in current" :key="item.id">
            <td>{{ item.serial }}</td>
            <td>{{ item.oltId }}</td>
            <td>{{ item.frame }}/{{ item.slot }}/{{ item.port }}</td>
            <td>{{ item.ontid }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-dialog v-model="dialog_loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Por favor aguarde
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import api from "../../api/index.js";
  import router from "../../router/index.js";
  export default {
    data: () => ({
      current: null,
      counter: 0,
      dialog_loading: false
    }),
    created: function() {
      this.list();
    },
    methods: {
      list: function() {
        var me = this;
        me.dialog_loading = true;
        var token = localStorage.getItem("token");
        api
          .get("/ont", { headers: { Authorization: "Bearer " + token } })
          .then(function(response) {
            me.current = response.data;
            me.counter = me.current.length;
          })
          .catch(function(error) {
            console.log(error);
          })
          .finally(()=>{
            me.dialog_loading = false;
          });
      },
      power: function() {
        router.push({ path: "/ont/power" });
      }
    }
  };
  </script>